import { useEffect, useState } from "react"
import { Loading } from "src/libs/useful"
import { shuffle } from "src/libs/utilities"
import { useUser } from "src/settings/zustand/user"
import { GET_TEST_ACTION } from "../../data/actionTypes"
import { actions } from "../../data/actions"
import { IPETest, PE_TEST_AUTH_TYPE } from "../../data/interfaces"
import { useTestsStore } from "../../data/store"
import SingleTest from "../single/SingleTest"

const TestsForm = ({setIsLogged, ...props}: any): JSX.Element => {
    const [item, setItem] = useState<IPETest>({} as IPETest)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const user = useUser()

    useEffect(() => { 
        actions(
            GET_TEST_ACTION, 
            {
                id: props.extend_params?.id,
                user_id: user.id, 
            }
        ).then(( result:IPETest ) => {
            const test: IPETest = {
                ...result, 
                questions: result.is_shuffle ? shuffle(result.questions) : result.questions
            }
            setIsLogged( test.auth_type === PE_TEST_AUTH_TYPE.AUTH)
            useTestsStore.setState({
                currentTest: test, 
                currentStep: 0,
                results : [],
                //tryCount : 0,
                waybill : [
                    "", 
                    ...test.questions.map(q => `question/${q.id.toString()}`), 
                    "finish", 
                    //"results"
                ]
            })
            setItem( test )
            setIsLoading(false)
        })
        return () => {
            useTestsStore.setState( { currentTest: {}, tryCount:0} )            
        }
    }, [  props.extend_params?.id ])
    if( isLoading) {
        return <div className="layout-state w-100 h-100 flex-centered">
            <Loading />
        </div>
    }
    return <div className="layout-state">
        <SingleTest item={item} />
    </div> 
} 

export default TestsForm